import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatError } from '@angular/material/form-field';
import { CountryISO, NgxMaterialIntlTelInputComponent } from 'ngx-material-intl-tel-input';
import { TranslateService } from '@ngx-translate/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'madero-phone-country-input',
  templateUrl: './phone-country-input.component.html',
  styleUrl: './phone-country-input.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [NgxMaterialIntlTelInputComponent, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatError, TranslatePipe],
})
export class PhoneCountryInputComponent {
  private readonly translateService = inject(TranslateService);
  readonly label = input('Telefone');
  readonly hint = input(true);
  readonly phoneControl = input.required<FormControl<string | null>>();
  readonly showValidations = input(true);
  readonly CountryISO = CountryISO;

  readonly required = computed(() => this.phoneControl().hasValidator(Validators.required));

  readonly textLabels = computed(() => ({
    mainLabel: '',
    codePlaceholder: this.translateService.instant('PORTAL.WAITING_LIST.PHONE.CODE_PLACEHOLDER'),
    searchPlaceholderLabel: this.translateService.instant('PORTAL.WAITING_LIST.PHONE.SEARCH_PLACEHOLDER'),
    noEntriesFoundLabel: this.translateService.instant('PORTAL.WAITING_LIST.PHONE.NO_COUNTRY_FOUND'),
    nationalNumberLabel: this.label(),
    hintLabel: this.hint() ? this.translateService.instant('PORTAL.WAITING_LIST.PHONE.PLACEHOLDER') : '',
    invalidNumberError: '',
    requiredError: '',
  }));
}
